module.exports = __webpack_public_path__ + "img/symbol_2.400f7624.png";